var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { "hide-footer": "", title: "Empfänger der Benachrichtigung" },
      on: {
        hide: function ($event) {
          return _vm.reset()
        },
      },
      model: {
        value: _vm.isModalOpen,
        callback: function ($$v) {
          _vm.isModalOpen = $$v
        },
        expression: "isModalOpen",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "record-note-recipients-modal loading-content-container",
        },
        [
          _vm.noteRecipientsLoading > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "loading-overlay d-flex justify-content-center pt-5",
                },
                [_c("csp-loading-indicator")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.noteRecipientsLoading === 0 &&
          _vm.noteRecipientsForTable.length === 0
            ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                _vm._v("\n            Keine Empfänger vorhanden\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.noteRecipientsLoading === 0 &&
          _vm.noteRecipientsForTable.length > 0
            ? _c("b-table", {
                attrs: {
                  fields: _vm.recipientTableFields,
                  items: _vm.noteRecipientsForTable,
                  responsive: true,
                  striped: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "table-colgroup",
                      fn: function (scope) {
                        return _vm._l(scope.fields, function (field) {
                          return _c("col", {
                            key: field.key,
                            style: { width: field.width ?? "auto" },
                          })
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  328078720
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }